import { call, put, takeEvery, all, select } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import {
  changeCandidatePositionRoutine,
  fetchCandidateDataRoutine,
  fetchReferencesRoutine,
  updateRefStatusRoutine
} from '../../routines';
import { getByCandidateId, updateRefStatus } from '../../../../services/referenceService';
import { updateCandidateOwner, getProfileCandidateData, updatePosition } from '../../../../services/candidateService';
import { createReqRefRoutine } from '../../../RequestBuilder/routines';
import { IAppState } from '../../../../common/models/store/IAppState';
import { updateCandidateOwnerRoutine } from '../../../../containers/CandidatesBulkActions/routines';
import { successToast, errorToast } from '../../../../common/helpers/toastrHelper';

function* getReferencesRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getByCandidateId, payload);
    yield put(fetchReferencesRoutine.success(response));
  } catch {
    yield put(fetchReferencesRoutine.failure());
  }
}

function* getCandidateDataRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getProfileCandidateData, payload);
    yield put(fetchCandidateDataRoutine.success(response));
  } catch {
    yield put(fetchCandidateDataRoutine.failure());
  }
}

function* updateCandidatesRequest({ payload }: Routine<any>) {
  try {
    yield call(updateCandidateOwner, payload);
    yield put(updateCandidateOwnerRoutine.success(payload));
    yield call(successToast, 'Candidate(s) reassigned', 'toast.candidateReassignSuccess');
  } catch (error) {
    yield put(updateCandidateOwnerRoutine.failure());
    yield call(errorToast, error.message);
  }
}

function* requestAdditionalRef() {
  const id = yield select(({ contactProfile: { contact: { candidateId } } }: IAppState) => candidateId);
  if (id) {
    yield put(fetchCandidateDataRoutine.trigger(id));
  }
}

function* updateCandidatePosition({ payload }: Routine<any>) {
  try {
    const data = yield call(updatePosition, payload);
    yield put(changeCandidatePositionRoutine.success({
      id: payload.id,
      positionId: data.positionId,
      positionName: payload.position.name
    }));
  } catch (error) {
    yield put(changeCandidatePositionRoutine.failure(error.message));
  }
}

function* updateRefStatusReq({ payload }: Routine<any>) {
  try {
    yield call(updateRefStatus, payload);
    yield put(updateRefStatusRoutine.success(payload));
  } catch (error) {
    yield put(updateRefStatusRoutine.failure(error.message));
  }
}

function* watchUpdateRefStatusReq() {
  yield takeEvery(updateRefStatusRoutine.TRIGGER, updateRefStatusReq);
}

function* watchGetReferencesRequest() {
  yield takeEvery(fetchReferencesRoutine.TRIGGER, getReferencesRequest);
}

function* watchGetCandidateDataRequest() {
  yield takeEvery(fetchCandidateDataRoutine.TRIGGER, getCandidateDataRequest);
}

function* watchUpdateCandidatesRequest() {
  yield takeEvery(updateCandidateOwnerRoutine.TRIGGER, updateCandidatesRequest);
}

function* watchCreateRefReq() {
  yield takeEvery(createReqRefRoutine.SUCCESS, requestAdditionalRef);
}

function* watchUpdateCandidatePosition() {
  yield takeEvery(changeCandidatePositionRoutine.TRIGGER, updateCandidatePosition);
}

export default function* contactReferencesSaga() {
  yield all([
    watchGetReferencesRequest(),
    watchGetCandidateDataRequest(),
    watchUpdateCandidatesRequest(),
    watchCreateRefReq(),
    watchUpdateCandidatePosition(),
    watchUpdateRefStatusReq()
  ]);
}
